import { useEffect } from 'react';
import feather from 'feather-icons';

// In a React SPA the feather icon nodes (`<i data-feather>`) mount after initial
// paint, so we re-run replace() after every render of a tree that contains them.
// `deps` lets callers re-run when their icon set changes.
export function useFeather(deps: ReadonlyArray<unknown> = []): void {
  useEffect(() => {
    feather.replace();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
